import { Outlet } from "react-router-dom";
import CustomerTabMenu from "./CustomerTabMenu";
import "./CustomerDashboardLayout.css";

const CustomerDashboardLayout = () => {
  return (
    <div className="cdl">
      <div className="cdl__viewport">
        <div className="cdl__shell">
          <aside className="cdl__sidebar">
            <div className="cdl__sidebar-inner">
              <CustomerTabMenu />
            </div>
          </aside>

          <main className="cdl__content">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
};

export default CustomerDashboardLayout;
